import React from "react";
import { Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";
import { useTranslation } from "react-i18next";
import PIDRow from "./PIDRow";

const PIDControllersForm = ({
  pidControllerSettings,
  handleOnChange,
  inputSelected,
}) => {
  const { t } = useTranslation("common");

  const settingsArray =
    pidControllerSettings &&
    Object.keys(pidControllerSettings).length > 0 &&
    Object.keys(pidControllerSettings).map((key) => pidControllerSettings[key]);

  return (
    <Table size="small" sx={{ m: 2 }}>
      <TableHead>
        <TableRow>
          <TableCell>{t("Name")}</TableCell>
          <TableCell align="center">{t("Set Point")} (°C)</TableCell>
          <TableCell align="center">{t("Autotune Done")}</TableCell>
          <TableCell align="center" />
        </TableRow>
      </TableHead>
      <TableBody>
        {settingsArray &&
          settingsArray.length > 0 &&
          settingsArray.map((row) => (
            <PIDRow
              key={`${row.name}PIDRow`}
              row={row}
              handleOnChange={handleOnChange}
              inputSelected={inputSelected}
            />
          ))}
      </TableBody>
    </Table>
  );
};

export default PIDControllersForm;
